export default class Feature {
  constructor(position, size, terrainType) {
    this.position = position;
    this.size = size;
    this.terrainType = terrainType;
  }
}
